import React from "react";
import { Icon } from "rhombus-react";

import "./VersionExportGrowl.css";

export default function VersionExportGrowl({ downloadLink, filename, description }){
	return (
		<div className="version-export-growl-body">
			<div className="version-export-description">{`${description || "Versions export"} is ready to download`}</div>
			<div>
				<a href={downloadLink} download={filename}>
					<Icon name="download" />
					Download Export
				</a>
			</div>
		</div>
	);
}
